import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "toggle"]
  static values = {
    visible: { type: Number, default: 3 },
    viewMore: String,
    viewLess: String
  }

  connect() {
    this.expanded = false
    this.update()
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    this.expanded = !this.expanded
    this.update()
  }

  collapseOnItemClick(event) {
    if (!this.expanded) return

    event.preventDefault()
    event.stopPropagation()
    this.expanded = false
    this.update()
  }

  update() {
    const items = this.itemTargets
    const hiddenCount = items.length - this.visibleValue

    if (hiddenCount <= 0) {
      if (this.hasToggleTarget) {
        this.toggleTarget.hidden = true
        this.toggleTarget.style.display = "none"
      }
      return
    }

    items.forEach((item, index) => {
      const shouldHide = !this.expanded && index >= this.visibleValue
      item.hidden = shouldHide
      item.style.display = shouldHide ? "none" : ""
    })

    if (this.hasToggleTarget) {
      const keepToggle = this.expanded && this.hasViewLessValue
      this.toggleTarget.hidden = this.expanded && !keepToggle
      this.toggleTarget.style.display = this.toggleTarget.hidden ? "none" : ""
      this.toggleTarget.setAttribute("aria-expanded", String(this.expanded))
      this.toggleTarget.textContent = keepToggle
        ? this.viewLessValue
        : this.viewMoreValue.replace("%{count}", hiddenCount)
    }
  }
}
